
let galleryId;
const galleries = document.querySelectorAll('.gallery-grid');

const gallerySliderInit = function() {
    galleries.forEach((galleryEl) => {
        const galleryId = galleryEl.getAttribute("data-gallery-id");
        const sliderSelector = `#gallery-slider-${galleryId}`;

        new Swiper(sliderSelector, {
            loop: true,
            freeMode: true,
            spaceBetween: 10,
            a11y: false,
            autoplay: {
                delay: 0.5,
                disableOnInteraction: false,
            },
            speed: 11000,
            freeModeMomentum: false,
            slidesPerView: 'auto',
            breakpoints: {
                768: {
                    spaceBetween: 20,
                },
            },
        });
    });
};


const galleryFancyboxInit = function() {
    galleries.forEach((galleryEl) => {
        galleryId = galleryEl.getAttribute('data-gallery-id');

        // Default gallery
        Fancybox.bind(`.gallery-default [data-fancybox="gallery-${galleryId}"]`, {
            buttons: [
                "close"
            ],
            loop: true,
            protect: false,
            controls : false,
            caption : (fancybox, item) => {
                const caption = item.caption || '';
                return (caption)
            }
        });

        // Slider gallery
        Fancybox.bind(`.gallery-slider [data-fancybox="gallery-${galleryId}"]`, {
            infobar: false,
            toolbar: false,
            arrows: false,
            caption : (fancybox, item) => {
                const caption = item.caption || '';
                return (caption)
            }
        });
    });
}

export { gallerySliderInit, galleryFancyboxInit };
